import { useTranslation } from "react-i18next";
import LoadingSpinner from "../../../../Components/Components/LoadingSpinner";
import OffersFilter from "./OffersFilter";
import Offer from "./Offer";
import { OfferCurrentView } from "../../../../Data/PageModeEnums.ts";
import { useParams } from "../../../../Providers/ParamsProvider.jsx";

const OffersTable = ({ offers, isLoading, currentView, handleCreateOfferRequest, handleCreateRetailerOffer, handleDeleteRetailerOfferFunc, handleDownloadPdf,
    downloadingOfferNo, setIsLoadingBasket, lastBookElementRef, offersFilter, setOffersFilter, handleEditOffer }) => {
    const { t } = useTranslation()
    const { isMobile } = useParams()

    const generateDateSection = () => {
        if (currentView === OfferCurrentView.OfferRetailer) {
            return (
                <th style={{ alignContent: "start", verticalAlign: 'top', width: "13%", fontSize: '14px' }}>
                    {t("date_table_header_offers_exp").toLocaleUpperCase()}
                </th>
            )
        }
        else if (currentView === OfferCurrentView.OfferRequest) {
            return (
                <th style={{ alignContent: "start", verticalAlign: 'top', width: "13%", fontSize: '14px' }}>
                    {t("date_table_header_offers_create").toLocaleUpperCase()}
                </th>
            )
        }
        else {
            return (
                <th style={{ alignContent: "start", verticalAlign: 'top', width: "13%", fontSize: '14px' }}>
                    <span style={{ fontWeight: 'normal' }}>{t("date_table_header_offers_create").toLocaleUpperCase()}</span>
                    <br />
                    {t("date_table_header_offers_exp").toLocaleUpperCase()}
                </th>
            )
        }
    }

    return (
        <div>
            <div className="row justify-content-center">
                <div className="justify-content-center">
                    <div className="col-12 col-xxl-11">
                        <OffersFilter
                            offersFilter={offersFilter}
                            setOffersFilter={setOffersFilter}
                            currentView={currentView}
                        />
                    </div>
                    <div className="table-responsive">
                        <table className={`${isMobile ? 'table-font-small' : ''} table table-bordered`}>
                            <thead>
                                <tr>
                                    <th style={{ alignContent: "start", verticalAlign: 'top', width: "15%", fontSize: '14px' }}>
                                        <span style={{ fontWeight: 'normal' }}>{t("number_table_header_offers_page").toLocaleUpperCase()}</span><br />
                                        {t("date_table_header_offers_ask").toLocaleUpperCase()}
                                    </th>
                                    <th style={{ alignContent: "start", verticalAlign: 'top', width: "auto", fontSize: '14px' }}>
                                        {currentView === OfferCurrentView.OfferRetailer ? "INWESTOR" : t("seller_table_header_orders_page").toLocaleUpperCase()}
                                    </th>
                                    {generateDateSection()}
                                    <th style={{ alignContent: "start", verticalAlign: 'top', width: "auto", fontSize: '14px' }}>
                                        {t("investment_table_header").toLocaleUpperCase()}
                                    </th>
                                    {currentView !== OfferCurrentView.OfferRetailer && <th style={{ alignContent: "start", verticalAlign: 'top', width: "8%", fontSize: '14px' }}>
                                        {t("status_table_header_unpaid_page").toLocaleUpperCase()}
                                    </th>}
                                    <th style={{ alignContent: "start", verticalAlign: 'top', width: "12%", fontSize: '14px', textAlign: 'right' }}>
                                        <span style={{ fontWeight: 'normal' }}>{t("netto_table_header_orders_page").toLocaleUpperCase()}</span><br />
                                        {t("value_table_header_unpaid_page").toLocaleUpperCase()}
                                    </th>
                                    {currentView !== OfferCurrentView.OfferRequest && <th style={{ alignContent: "start", verticalAlign: 'top', width: "3%", textAlign: 'right' }}></th>}
                                    {currentView === OfferCurrentView.OfferCustomer && <th style={{ alignContent: "start", verticalAlign: 'top', width: "3%", textAlign: 'right' }}></th>}
                                    {currentView === OfferCurrentView.OfferRetailer && <>
                                        <th style={{ alignContent: "start", verticalAlign: 'top', width: "3%", textAlign: 'right' }}></th>
                                        <th style={{ alignContent: "start", verticalAlign: 'top', width: "3%", textAlign: 'right' }}></th>
                                    </>}
                                    {currentView === OfferCurrentView.OfferRequest && <th style={{ alignContent: "start", verticalAlign: 'top', width: "2%", textAlign: 'right' }} />}
                                </tr>
                            </thead>
                            <tbody className="element-pointer">
                                {offers &&
                                    offers.map((offer, index) => {
                                        return <Offer
                                            key={index}
                                            offer={offer}
                                            currentView={currentView}
                                            handleCreateOfferRequest={handleCreateOfferRequest}
                                            handleCreateRetailerOffer={handleCreateRetailerOffer}
                                            handleDeleteRetailerOfferFunc={handleDeleteRetailerOfferFunc}
                                            handleDownloadPdf={handleDownloadPdf}
                                            isDownloadingPdf={downloadingOfferNo === offer.offerNo}
                                            setIsLoadingBasket={setIsLoadingBasket}
                                            lastBookElementRef={lastBookElementRef}
                                            handleEditOffer={handleEditOffer}
                                        />
                                    })}
                            </tbody>
                        </table>
                        {isLoading && <LoadingSpinner />}
                        {!isLoading && offers && offers.length === 0 && (
                            <div style={{ textAlign: "center" }}>
                                {t("message_norecords_offers_page")}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OffersTable;
